// extracted by mini-css-extract-plugin
export default {"blocksWrapper":"Loader_blocksWrapper__InCeW"};